import { Capacitor } from '@capacitor/core';

/** Open HTTPS/mailto links — works in browser and Capacitor Android WebView. */
export function openExternalUrl(url) {
  if (!url || typeof window === 'undefined') return;
  if (Capacitor.isNativePlatform()) {
    const popup = window.open(url, '_blank');
    if (!popup) window.location.assign(url);
    return;
  }
  window.open(url, '_blank', 'noopener,noreferrer');
}
